module.exports.name = 'morteros-tecnicos'
module.exports.projects = [
    {
        url: '/soluciones-tecnicas/morteros-tecnicos/estructurales',
        title: 'Estructurales',
        image: () => require('./images/estructurales-2.jpg'),
        html: `
            Tiene problema estructurales en su vivienda. ¡No se preocupe!... Si existe la solución,
            nosotros la tenemos...
            <br />
            <br />
            La vulnerabilidad de las estructuras, suele reflejase a través de patologías que aparecen
            en las edificaciones, ocasionando múltiples efectos, desde pequeños daños y molestias
            para sus ocupantes, hasta grandes fallas que pueden causar el colapso de la edificación
            o parte de ella.
        `,
        htmlFull: () => `
            Tiene problema estructurales en su vivienda. ¡No se preocupe!... Si existe la solución,
            nosotros la tenemos...
            <br />
            <br />
            La vulnerabilidad de las estructuras, suele reflejase a través de patologías que aparecen
            en las edificaciones, ocasionando múltiples efectos, desde pequeños daños y molestias
            para sus ocupantes, hasta grandes fallas que pueden causar el colapso de la edificación
            o parte de ella.
            <br />
            <br />
            Detallamos algunos pasos sobre la ejecución y características
            especiales sobre los morteros para su aplicación:
            <img src="${require('./images/estructurales-1.jpg')}" />
            Identificar el problema ,tomar las medidas de seguridad que correspondan e Iniciaremos el
            saneamiento de la zona a tratar desde una viga en una fahada a un pilar...
            <img src="${require('./images/estructurales-2.jpg')}" />
            Aquí observamos un pilar al cual se le ha reforzado con un armazon de hierro y con un
            primer vertido con alguno de nuestras posibles soluciones en geomorteros.
            <br />
            <br />
            "Geomorteos R4  que garantizan que  las reparaciones sean estables y duraderas como una piedra..."
            <img src="${require('./images/estructurales-3.jpg')}" />
            Se pueden utilizar algunas de nuestras soluciones en geo morteros para un pavimento,
            alta dureza-rapida puesta en marcha (fraguados rapidos) podras pasar un vehiculos
            y todo tipo de maquinaria industrial sin problemas...
            (Parking-Garajes –Camaras frigorificas-etc...)
        `,
    },
    {
        url: '/soluciones-tecnicas/morteros-tecnicos/tecnicos',
        title: 'Técnicos',
        image: () => require('./images/tecnicos-1.jpg'),
        html: `
            "A veces, no tener un buen soporte nivelado y liso conlleva que trabajos posteriores no queden con el mejor acabado"
            <br />
            <br />
            Siempre partiremos, de la identificación del problema que ha causado, que el soporte se 
            haya deteriorado ya sea por causa de tráfico rodado, fallo estructural, filtración, etc,
            o simplemente quieres una mejora decorativa o te apetece colocar para esos días de frio
            un suelo radiante, tenemos la solución definitiva, con la garantía de los mejores
            productos del mercado. 
        `,
        htmlFull: () => `
            "A veces, no tener un buen soporte nivelado y liso conlleva que trabajos posteriores no queden con el mejor acabado"
            <br />
            <br />
            Siempre partiremos, de la identificación del problema que ha causado, que el soporte se 
            haya deteriorado ya sea por causa de tráfico rodado, fallo estructural, filtración, etc,
            o simplemente quieres una mejora decorativa o te apetece colocar para esos días de frio
            un suelo radiante, tenemos la solución definitiva, con la garantía de los mejores
            productos del mercado. 
            <img src="${require('./images/tecnicos-1.jpg')}" />
            Imprimaciones para soportes tanto al agua como bases solventes,
            barreras de vapor en resinas epoxi, etc...
            <img src="${require('./images/tecnicos-2.jpg')}" />
            Soleras Semi-secas compactas, de rápida puesta en marcha aptas también para la
            trasmisión del calor en suelos calefactados...
            <img src="${require('./images/tecnicos-3.jpg')}" />
            La mejor alternativa en autonivelantes en diferentes composiciones, para adaptar a
            cualquier tipo de espesor y soporte y resistencia mecánica, en diferentes tipos
            de fraguado. 
            <br />
            <br />
            <h3>Protección de Fachadas e interiores:</h3>
            <br />
            Una gama amplia de morteros para exterior como para interior en base cal, yeso o cementosa.
            <br />
            <br />
            Morteros de acabado y protección, tanto para obra nueva como rehabilitación exterior e
            interior…alisados gotelé o tirolianos, arreglar desperfectos tras retirar papel o
            piedras exteriores, soportes pintados, etc...
            <img src="${require('./images/tecnicos-4.jpg')}" />
            Una opción clara para utilizar el enfoscado y los  morteros de alisado a base de cal
            resistente a la compresión M5,traspirables. INT-EXT, son aquellos muros de tufo
            volcánico, ladrillos, bloques ,piedras y paredes mixtas
            <img src="${require('./images/tecnicos-5.jpg')}" />
            Elije el mejor mortero  que se adecúe a tu soporte 
            <img src="${require('./images/tecnicos-6.jpg')}" />
            Morteros con elevada adhesión sobre soportes difíciles cerámicas, pinturas,etc
            <img src="${require('./images/tecnicos-7.jpg')}" />
            Diferentes tipos de acabado desde un grano más grueso hasta morteros para la eliminación
            del gotelé con un aspecto liso y pulido
        `,
    },
]


// WEBPACK FOOTER //
// ./src/data/morteros-tecnicos.js